import { ReactSession }  from 'react-client-session';

export const getTranslation = (content_state, page, attribute, backup) => {
    try {
        return content_state[ReactSession.get("language")][page][attribute]
    } catch (error) {
        return backup
    }
}